import { type FC, type ReactNode } from "react"
import styled, { css } from "styled-components"

import { cn } from "@forento/ui/utilities/tailwind"

import Button from "~/components/Button"
import GoogleSigninButtonBase from "~/components/GoogleSigninButton"
import { useBrand } from "~/contexts/BrandContext"
import { dangerColor } from "~/utilities/styles"

const Layout: FC<{ children: ReactNode }> = ({ children }) => {
	const brand = useBrand()

	return (
		<div className="bg-component-background flex min-h-screen w-full flex-col justify-between p-4">
			<div />
			<div className="flex flex-col items-center justify-center">{children}</div>
			<div className="flex flex-col items-center justify-center space-y-2 py-6 text-center">
				<div className="text-sm text-gray-600">
					&copy; {new Date().getFullYear()} {brand.legalName}. All rights reserved.
				</div>
				<div className="flex items-center space-x-6 text-sm">
					<a
						href="https://forento.link/terms"
						rel="noreferrer"
						target="_blank"
						className="text-gray-500 underline-offset-2 transition-colors duration-200 hover:text-gray-700 hover:underline"
					>
						Terms of service
					</a>
					<div className="size-1 rounded-full bg-gray-400" />
					<a
						href="https://forento.link/privacy"
						rel="noreferrer"
						target="_blank"
						className="text-gray-500 underline-offset-2 transition-colors duration-200 hover:text-gray-700 hover:underline"
					>
						Privacy policy
					</a>
				</div>
			</div>
		</div>
	)
}

export const Logo: FC<{ className?: string }> = ({ className }) => {
	const brand = useBrand()

	return <img alt={`${brand.name}'s logo`} src={brand.logoUrl} className={cn("mb-12 w-36", className)} />
}

export const Title = styled.h1`
	font-weight: 600;
	font-size: 26px;
	text-align: center;
`

export const Text = styled.p`
	font-weight: 500;
	font-size: 16px;
	text-align: center;
`

export const Content = styled.div<{ $uncappedWidth?: boolean }>`
	width: 100%;
	${props =>
		!props.$uncappedWidth &&
		css`
			max-width: 360px;
		`}
	display: flex;
	flex-direction: column;
	align-items: stretch;
	gap: 24px;
`

export const Inputs = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
`

export const InputsRow = styled.div`
	display: flex;
	gap: 20px;
`

export const NavigationText = styled.p`
	font-size: 14px;
	color: #667085;
	text-align: center;
`

export const NavigationButton = styled(Button)`
	display: inline;
	font-size: 14px;
	color: #6941c6;
	align-self: flex-end;
`

export const GoogleSigninButton = styled(GoogleSigninButtonBase)`
	align-self: center;
`

export const ErrorText = styled(Text)`
	color: ${dangerColor};
`

export { default as BackButton } from "./BackButton"

export default Layout
